import { render, staticRenderFns } from "./gameMenu.vue?vue&type=template&id=0f2d6f3a&"
import script from "./gameMenu.vue?vue&type=script&lang=js&"
export * from "./gameMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports